<template>
    <div class="card-new-item" @click="gotoPage()">
        <div class="card-new-item__icon">
            <img src="@/assets/images/icons/plus.svg" />
        </div>
        <h2 class="header-2 card-new-item__text">
            {{title}}
        </h2>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                default: ''
            },
            path: {
                type: String,
                default: '',
            }
        },
        methods: {
            gotoPage(){
                if(this.path != null)
                    this.$router.push(this.path);
                else
                    return;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .card-new-item{
    width: 100%;
    max-width: 300px;
    height: 300px;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-shadow: 0px 0px 5px #0000001A;
    background: linear-gradient(180deg, $color-secondary 0%, $color-primary 100%);
    transition: transform 0.5s;
    cursor: pointer;

    &:hover{
        transform: scale(1.01);
        transition: transform 0.3s;
    }

    &__icon{
        margin: 10px auto;
        display: flex;
        padding: 20px;
        border-radius: 50%;
        background-color: $color-secondary;
        box-shadow: 20px 20px 60px #00000066;

        img{
            margin: auto;
        }
    }

    &__text{
        margin: 10px auto;
        font-weight: 700;
        color: white;
        text-align: center;
        backface-visibility: hidden;
    }
}
</style>